import { useState, useEffect, useCallback } from 'react'
import { api, type User } from '@/lib/api'
import { identifyUser, resetUser } from '@/lib/analytics'

export function useAuth() {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    try {
      const { user } = await api.getMe()
      setUser(user)
      identifyUser(user)
    } catch {
      setUser(null)
    }
  }, [])

  useEffect(() => {
    refresh().finally(() => setLoading(false))
  }, [refresh])

  const logout = async () => {
    await api.logout()
    setUser(null)
    resetUser()
    window.location.href = '/'
  }

  return { user, loading, logout, setUser, refresh }
}
